module.exports = __webpack_public_path__ + "img/nebraska-lincoln-pd.4652e07b.png";